var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-download","mode":"out-in"}},[(_vm.downloadWaitNumber > 0)?_c('div',{staticClass:"parent-download-loader"},[_c('v-icon',{staticClass:"spinner"},[_vm._v("\n      fas fa-spinner\n    ")]),_vm._v(" "),_c('v-icon',{staticClass:"file"},[_vm._v("\n      fas fa-file\n    ")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0336022c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/DownloadLoad.vue
// module id = null
// module chunks = 